import AVAILABILITY from '@constants/product';
import Product from '@customTypes/product';

export default function useSoldOut() {
  function getSoldOutTextForProduct(product: Product) {
    if (product.product_type === 'event') {
      return AVAILABILITY.UNAVAILABLE;
    }

    return AVAILABILITY.SOLD_OUT;
  }

  return { getSoldOutTextForProduct };
}
